jQuery(document).ready(function($) {

  var $posts_grid = $('.post-listing').isotope({
    itemSelector: '.post-item',
    layoutMode: 'fitRows'
  });

  $('.post-sorting input[type="checkbox"]').on('change', function() {
    // console.log(filterPosts());
    $posts_grid.isotope({
      filter: filterPosts().join(', ')
    });

    // setTimeout(function() {
    //   $posts_grid.isotope('layout');
    // }, 500);
  });

  $('#posts-clear-filter').click(function() {
    $('.post-sorting input[type="checkbox"]:checked').each(function() {
      $(this).prop('checked', false);
    });
    $posts_grid.isotope({
      filter: '*'
    });
    $(this).blur();
  });

  function filterPosts() {
    var post_filters = [];

    $('.post-sorting input[type="checkbox"]:checked').each(function() {
      post_filters.push('[data-tags*="'+$(this).val()+'"]');
    });

    return post_filters;
  }

  if($(window).width() >= 1024 && $('.post-sort-container').length) {
    $('.post-sort-container').foundation('toggle', $('#post-sort-container-content'));
  }

});
